import { Link } from "@quintype/components";
import React from "react";
import User from "../../atoms/other-icons/User";
import "./hamburger-my-account-button.m.css";

function HamburgerMyAccountButton() {
  return (
    <div styleName="wrapper">
      <Link href="/profile" styleName="my-account" target="_blank">
        <User width="16px" height="17.33px" />
        Profile
      </Link>
    </div>
  );
}

export default HamburgerMyAccountButton;
